// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselServiceConfigure\VesselServiceConfigureResult.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// VesselServiceConfigureData is the class that VesselServiceConfigure serializes to/from
export interface VesselServiceConfigureData {
    VesselId : number;
	
    DuplicateVessels : VesselData[] | null;
    Vessel : VesselData | null;
	
}

// VesselServiceConfigureOptions is the class which may be passed to the VesselServiceConfigure constructor to define optional initial data values
export interface VesselServiceConfigureOptions {
    VesselId : number;
	
    DuplicateVessels? : VesselOptions[] | null;
    Vessel? : VesselOptions | null;
	
}

export class VesselServiceConfigure {
    public VesselId : DataSignal<number>;
	
    public DuplicateVessels : SDataArray<Vessel>;
    public Vessel : DataSignal<Vessel | null>;
	

    constructor();
    constructor(data : VesselServiceConfigureOptions);
    constructor(data: VesselServiceConfigureOptions | null = null) {
        this.VesselId = jsonableObservable(S.value<number>(data && data.VesselId !== undefined ? data.VesselId : 0));
	    
        this.DuplicateVessels = SArray<Vessel>([]);
        this.Vessel = S.value<Vessel | null>(null);
	    
    }

    static key(obj : VesselServiceConfigure) {
        return obj.VesselId();
    }
    
    static dataKey(obj : VesselServiceConfigureOptions) {
        return obj.VesselId;
    }

    static update(obj : VesselServiceConfigure, data : VesselServiceConfigureOptions) {
        S.freeze(() => {
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/VesselServiceConfigure.ts